import ko from 'knockout';
import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const isOriginalDeviceTargetingEnabled = _.result(config.get('Permissions'), 'IsOriginalDeviceTargetingEnabled');
const isExpandedDeviceTargetingEnabled = !isOriginalDeviceTargetingEnabled;
const bidAdjustmentIncreaseText = i18n.get('BidAdjustment_IncreaseText');
const bidAdjustmentDecreaseText = i18n.get('BidAdjustment_DecreaseText');
const bidAdjustmentIncreaseValue = 1;
const bidAdjustmentDecreaseValue = -1;
const ageMinimumBid = 90;
const ageMaximumBid = 900;
const genderMinimumBid = 90;
const genderMaximumBid = 900;
const deviceTabletsMinimumBid = isExpandedDeviceTargetingEnabled ? 100 : 20;
const deviceTabletsMaximumBid = isExpandedDeviceTargetingEnabled ? 900 : 300;
const deviceSmartphonesMinimumBid = isExpandedDeviceTargetingEnabled ? 100 : 90;
const deviceSmartphonesMaximumBid = isExpandedDeviceTargetingEnabled ? 900 : 300;
const specialDeviceSmartphonesBidAdjustmentValue = 100;
const deviceComputersMinimumBid = 100;
const deviceComputersMaximumBid = 900;
const locationMinimumBid = 90;
const locationMaximumBid = 900;
const nativeAdMinimumBid = 100;
const nativeAdMaximumBid = 900;
const multimediaAdMinimumBid = 20;
const multimediaAdMaximumBid = 900;
const multimediaAdDefaultBid = 40;

export default {
  bidAdjustmentIncreaseText,
  bidAdjustmentDecreaseText,
  bidAdjustmentIncreaseValue,
  bidAdjustmentDecreaseValue,
  multimediaAdDefaultBid,
  minimumBid: {
    'AgeType_EighteenToTwentyFive': ageMinimumBid,
    'AgeType_TwentyFiveToThirtyFive': ageMinimumBid,
    'AgeType_ThirtyFiveToFifty': ageMinimumBid,
    'AgeType_FiftyToSixtyFive': ageMinimumBid,
    'AgeType_SixtyFiveAndAbove': ageMinimumBid,
    'DeviceType_Tablets': deviceTabletsMinimumBid,
    'DeviceType_Smartphones': deviceSmartphonesMinimumBid,
    'DeviceType_Computers': deviceComputersMinimumBid,
    'GenderType_Male': genderMinimumBid,
    'GenderType_Female': genderMinimumBid,
    'NativeAdType_NativeAdsBids': nativeAdMinimumBid,
    'MultimediaAdType_MultimediaAdsBids': multimediaAdMinimumBid,
    'Location': locationMinimumBid,
  },
  maximumBid: {
    'AgeType_EighteenToTwentyFive': ageMaximumBid,
    'AgeType_TwentyFiveToThirtyFive': ageMaximumBid,
    'AgeType_ThirtyFiveToFifty': ageMaximumBid,
    'AgeType_FiftyToSixtyFive': ageMaximumBid,
    'AgeType_SixtyFiveAndAbove': ageMaximumBid,
    'DeviceType_Tablets': deviceTabletsMaximumBid,
    'DeviceType_Smartphones': deviceSmartphonesMaximumBid,
    'DeviceType_Computers': deviceComputersMaximumBid,
    'GenderType_Male': genderMaximumBid,
    'GenderType_Female': genderMaximumBid,
    'NativeAdType_NativeAdsBids': nativeAdMaximumBid,
    'MultimediaAdType_MultimediaAdsBids': multimediaAdMaximumBid,
    'Location': locationMaximumBid,
  },
  bidAdjustmentOptions: ko.observableArray([
    {
      text: bidAdjustmentIncreaseText,
      value: bidAdjustmentIncreaseValue,
    }, {
      text: bidAdjustmentDecreaseText,
      value: bidAdjustmentDecreaseValue,
    },
  ]),
  multimediaBidAdjustmentOptions: ko.observableArray([
    {
      text: bidAdjustmentIncreaseText,
      value: bidAdjustmentIncreaseValue,
    },
  ]),

  rowKeys: {
    'Age': [
      'EighteenToTwentyFive',
      'TwentyFiveToThirtyFive',
      'ThirtyFiveToFifty',
      'FiftyToSixtyFive',
      'SixtyFiveAndAbove',
    ],
    'Device': isOriginalDeviceTargetingEnabled || isExpandedDeviceTargetingEnabled ? [
      'Computers',
      'Tablets',
      'Smartphones',
    ] : [
      'Tablets',
      'Smartphones',
    ],
    'Gender': [
      'Male',
      'Female',
    ],
    'NativeAd': [
      'NativeAdsBids',
    ],
    'MultimediaAd': [
      'MultimediaAdsBids',
    ],
  },

  osNames: {
    'Computers': [
      'Windows',
    ],
    'Tablets': [
      'Android',
      'BlackBerry',
      'iOS',
      'Other',
    ],
    'Smartphones': [
      'Android',
      'BlackBerry',
      'iOS',
      'Windows',
      'Other',
    ],
  },

  targetTypeToFilterProperty: {
    'Age': 'AgeRange',
    'Gender': 'GenderType',
    'Device': 'DeviceName',
    'NativeAd': 'NativeAd',
    'MultimediaAd': 'MultimediaAd',
  },

  specialDeviceSmartphonesBidAdjustmentValue,
};
